export enum EAlert {
  Info = 'info',
  Success = 'success',
  Error = 'error',
}
